<template>
  <div class="video-page" v-title data-title="卓考网校|免费领取精品课程">
    <header class="g-header-container">
      <c-header title="免费领课" />
    </header>
    <main class="g-view-container">
      <img class="header-img" src="@/assets/img/banner@video.png" />
      <video-receive class="video-receive" />
      <video-audit />
    </main>
    <footer class="g-footer-container">
      <c-tabbar />
    </footer>
  </div>
</template>

<script>
  import CHeader from 'components/header';
  import CTabbar from 'components/tabbar';
  import VideoReceive from './receive';
  import VideoAudit from './audit';

  export default {
    name: 'Course',
    components: {
      CHeader,
      CTabbar,
      VideoReceive,
      VideoAudit,
    },
  };
</script>

<style lang="scss" scoped>
.header-img {
  margin-bottom: 20px;
  width: 100%;
}
.video-receive {
  margin-bottom: 20px;
}
</style>
